import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';


import {DatePipe} from '../pipe/datePipe';
import {NgbdDatepickerJalaliComponent} from '../../management/layouts/calender/jalali-calender/datepicker-jalali';
import {NgbDatepickerMiladiComponent} from '../../management/layouts/calender/miladi-calender/miladi-datepicker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatInputModule} from '@angular/material/input';
import {UserCardComponent} from '../userCard/userCard.component';
import {NestedSelectComponent} from '../nested-select/nested-select.component';
import {ModalComponent} from '../modals/addEditDel/modal.component';
import {UploadFileModalComponent} from '../modals/uploadFile-modal/uploadFileModal.component';
import {ImageViewerModalComponent} from '../modals/image-viewer-modal/imageViewerModal..component';
import {ProfileModalComponent} from '../modals/profile-modal/profileModal.component';
import {FileSaverModule} from 'ngx-filesaver';
import {MaterialModule} from '../../material-module';
import {ImageCropperModule} from '../image-cropper/image-cropper.module';
import {QuillModule} from 'ngx-quill';
import {RouterModule} from '@angular/router';



@NgModule({
  declarations: [DatePipe,
    NgbdDatepickerJalaliComponent,
    UserCardComponent,
    NestedSelectComponent,
    ModalComponent,
    UploadFileModalComponent,
    ProfileModalComponent,
    ImageViewerModalComponent,
    NgbDatepickerMiladiComponent,],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    FileSaverModule,
    MaterialModule,
    ImageCropperModule,
    TranslateModule,
    MatSlideToggleModule,
    MatInputModule,
    ReactiveFormsModule,
    QuillModule.forRoot(),
    RouterModule
  ],
  exports: [DatePipe,
    UserCardComponent,
    ModalComponent,
    UploadFileModalComponent,
    ImageViewerModalComponent,
    ProfileModalComponent,
    NestedSelectComponent,
    NgbdDatepickerJalaliComponent,
    NgbDatepickerMiladiComponent,
    CommonModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    FileSaverModule,
    MaterialModule,
    ImageCropperModule,
    TranslateModule,
    MatSlideToggleModule,
    MatInputModule,
    ReactiveFormsModule,

  ]
})
export class SharedModule {
}
